<script lang="ts">
    export let checked;
    export let label;
    export let name;
    export let error = null;
</script>

<div class="py-3">
    <div class="is-flex is-align-items-center">
        <input bind:checked type="checkbox" id="{name}" name="{name}">
        <label class="checkbox ml-3" for="{name}">{label}</label>
    </div>
    {#if error}
        <p class="help is-danger">{error}</p>
    {/if}
</div>